"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const playerProxy_1 = require("../playerStrategies/playerProxy");
const PlayerStrategyManager2_1 = require("../playerStrategies/PlayerStrategyManager2");
const nouislider_1 = __importDefault(require("nouislider"));
const updateMassages_1 = require("./updateMassages"); // TypeScript 會自動解析 .ts 檔案
const columnArticle_1 = require("./columnArticle"); // TypeScript 會自動解析 .ts 檔案
class PlayerController {
    constructor(container) {
        this.container = container;
        this.playerProxy = new playerProxy_1.PlayerProxy({
            isPaused: true,
            volume: 0.6,
            duration: 0,
            currentTime: 0,
            trackName: null,
        });
        this.mainPlayer = new PlayerStrategyManager2_1.MainPlayer(this.playerProxy);
        this.playerContainer = document.createElement('div');
        this.playerContainer.id = 'playerContainer';
        this.playerContainer.className = 'player-container';
        this.container.appendChild(this.playerContainer);
    }
    init() {
        this.createLeftButtonsContainer();
        this.createProgressBar();
        this.createRightButtonsContainer();
        console.log('PlayerController UI initialized');
    }
    createLeftButtonsContainer() {
        const leftButtonsContainer = document.createElement('div');
        leftButtonsContainer.className = 'left-buttons-container';
        leftButtonsContainer.appendChild(this.createModeToggleButton());
        leftButtonsContainer.appendChild(this.createUploadButton());
        leftButtonsContainer.appendChild(this.createPlayPauseButton());
        this.playerContainer.appendChild(leftButtonsContainer);
    }
    createRightButtonsContainer() {
        const rightButtonsContainer = document.createElement('div');
        rightButtonsContainer.className = 'right-buttons-container';
        rightButtonsContainer.appendChild(this.createVolumeControl());
        rightButtonsContainer.appendChild(this.createArticleButton());
        rightButtonsContainer.appendChild(this.createGuildlineButton());
        this.playerContainer.appendChild(rightButtonsContainer);
        console.log('Right Buttons Container created and appended:', rightButtonsContainer);
    }
    // leaf-buttom
    createModeToggleButton() {
        const modeToggleButton = document.createElement('sl-icon-button');
        modeToggleButton.id = 'modeToggleButton';
        modeToggleButton.className = 'mode-toggle-btn left-button';
        modeToggleButton.setAttribute('name', 'toggle2-off');
        modeToggleButton.setAttribute('title', 'Toggle to Spotify and WebAudio mode');
        modeToggleButton.style.fontSize = '3rem';
        modeToggleButton.addEventListener('click', () => {
            const isOff = modeToggleButton.getAttribute('name') === 'toggle2-off';
            modeToggleButton.setAttribute('name', isOff ? 'toggle2-on' : 'toggle2-off');
            this.mainPlayer.toggleMode(isOff ? 'spotify' : 'webaudio');
        });
        // this.playerContainer.appendChild(modeToggleButton);
        return modeToggleButton; // 返回 modeToggleButto
    }
    createUploadButton() {
        const uploadButton = document.createElement('sl-icon-button');
        uploadButton.id = 'uploadButton';
        uploadButton.className = 'upload-button left-button'; // 添加 class，符合新的格式
        uploadButton.setAttribute('name', 'upload'); // 使用上傳圖標，確保 Shoelace 圖標庫中有此圖標
        uploadButton.setAttribute('label', 'Upload'); // 設置無障礙標籤
        uploadButton.style.fontSize = '2rem';
        uploadButton.addEventListener('click', () => __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.mainPlayer.update();
                this.playerProxy.setState('isPaused', true);
                this.mainPlayer.pause();
            }
            catch (error) {
                console.error('An error occurred during track update:', error);
            }
        }));
        // this.playerContainer.appendChild(uploadButton);
        return uploadButton;
    }
    createPlayPauseButton() {
        const playPauseButton = document.createElement('sl-icon-button');
        playPauseButton.id = 'playPauseButton';
        playPauseButton.className = 'play-pause-btn left-button';
        playPauseButton.setAttribute('name', 'play'); // 使用上傳圖標，確保 Shoelace 圖標庫中有此圖標
        playPauseButton.setAttribute('label', 'Upload'); // 設置無障礙標籤
        playPauseButton.style.fontSize = '3rem';
        playPauseButton.textContent = '播放';
        this.playerProxy.on('isPaused', (isPaused) => {
            playPauseButton.setAttribute('name', isPaused ? 'play' : 'pause');
        });
        playPauseButton.addEventListener('click', () => {
            const isPaused = this.playerProxy.getState('isPaused');
            if (isPaused) {
                this.mainPlayer.play();
            }
            else {
                this.mainPlayer.pause();
            }
        });
        // this.playerContainer.appendChild(playPauseButton);
        return playPauseButton;
    }
    // ProgressBar
    createProgressBar() {
        return __awaiter(this, void 0, void 0, function* () {
            const progressWrapper = document.createElement('div');
            progressWrapper.id = 'progressWrapper';
            progressWrapper.classList.add('progress-wrapper');
            const progressLabelsRow = document.createElement('div');
            progressLabelsRow.id = 'progressLabelsRow';
            progressLabelsRow.classList.add('progress-LabelsRow');
            const minLabel = document.createElement('div');
            minLabel.id = 'minLabel';
            minLabel.classList.add('progress-label');
            minLabel.textContent = '0:00'; // 初始文字
            const maxLabel = document.createElement('div');
            maxLabel.id = 'maxLabel';
            maxLabel.classList.add('progress-label');
            maxLabel.textContent = '0:00'; // 初始文字
            const trackNameLabel = document.createElement('div');
            trackNameLabel.id = 'trackNameLabel';
            trackNameLabel.classList.add('progress-label');
            trackNameLabel.textContent = ''; // 初始文字
            const progress = document.createElement('div');
            progress.id = 'progressBar';
            progress.classList.add('progress-bar');
            progressLabelsRow.appendChild(minLabel);
            progressLabelsRow.appendChild(trackNameLabel);
            progressLabelsRow.appendChild(maxLabel);
            progressWrapper.appendChild(progressLabelsRow);
            progressWrapper.appendChild(progress);
            this.playerContainer.appendChild(progressWrapper);
            // 初始化 noUiSlider
            const sliderInstance = nouislider_1.default.create(progress, {
                start: [0],
                range: { min: 0, max: 100 },
                step: 1,
                connect: [true, false],
                pips: {
                    mode: 'range',
                    density: 2,
                    format: {
                        to: (value) => this.formatTime(value),
                        from: (value) => parseFloat(value) || 0,
                    },
                },
            });
            // event
            this.playerProxy.on('trackName', (newTrackName) => {
                trackNameLabel.textContent = newTrackName || 'Unknown Track';
                console.log(`[Proxy] Track name updated to: ${newTrackName}`);
            });
            this.playerProxy.on('duration', (newDuration) => {
                sliderInstance.updateOptions({
                    range: { min: 0, max: newDuration },
                    step: newDuration * 0.001,
                }, false);
                maxLabel.textContent = this.formatTime(newDuration);
            });
            let isSliding = false;
            window.sliderInstance = sliderInstance;
            sliderInstance.on('start', () => {
                console.log('Slider is being dragged.');
                isSliding = true;
            });
            sliderInstance.on('slide', (values) => {
                const newTime = typeof values[0] === 'string' ? parseFloat(values[0]) : values[0];
                console.log('Slider Values (ms):', newTime);
                this.mainPlayer.seekTo(newTime);
            });
            sliderInstance.on('end', () => {
                console.log('Slider drag ended.');
                isSliding = false;
            });
            this.playerProxy.on('currentTime', (newTime) => {
                if (isSliding) {
                    console.log('[Proxy] Skipping update because slider is being dragged.');
                    return;
                }
                sliderInstance.set(newTime);
                console.log(`[Proxy] Slider updated to: ${newTime}`);
                sliderInstance.updateOptions({
                    pips: {
                        mode: 'range',
                        density: 2,
                        format: {
                            to: (value) => {
                                if (value === sliderInstance.options.range.min) {
                                    return this.formatTime(newTime);
                                }
                                return this.formatTime(value);
                            },
                            from: (value) => parseFloat(value) || 0,
                        },
                    },
                }, true);
                minLabel.textContent = this.formatTime(newTime);
            });
        });
    }
    formatTime(ms) {
        const seconds = Math.floor(ms / 1000);
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
    }
    // right-button
    createVolumeControl() {
        const volumeControl = document.createElement('div');
        volumeControl.id = 'volumeController';
        volumeControl.classList.add('volume-controller', 'right-button');
        nouislider_1.default.create(volumeControl, {
            start: [0.6],
            range: { min: 0, max: 1 },
            step: 0.005,
            behaviour: 'drag',
            orientation: 'vertical',
            direction: 'rtl',
            connect: [true, false],
        });
        // listener
        const sliderInstance = volumeControl.noUiSlider;
        sliderInstance.on('update', (values) => {
            const volume = parseFloat(values[0]);
            this.mainPlayer.setVolume(volume);
        });
        sliderInstance.on('end', (values) => {
            const volume = parseFloat(values[0]);
            console.log(`Slider released, final volume: ${volume}`);
            this.mainPlayer.setVolume(volume);
        });
        this.playerProxy.on('volume', (volume) => {
            sliderInstance.set(volume);
        });
        // this.playerContainer.appendChild(volumeControl);
        return volumeControl;
    }
    createGuildlineButton() {
        // 創建按鈕
        const guildlineButton = document.createElement('sl-icon-button');
        guildlineButton.id = 'guildlineButton';
        guildlineButton.className = 'guildline-btn right-button';
        guildlineButton.setAttribute('name', 'question-square');
        guildlineButton.style.fontSize = '2rem';
        // 創建模態框
        const modal = document.createElement('div');
        modal.id = 'comingSoonModal';
        modal.style.position = 'fixed';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        modal.style.display = 'flex';
        modal.style.justifyContent = 'center';
        modal.style.alignItems = 'center';
        modal.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        modal.style.zIndex = '1000';
        modal.style.visibility = 'hidden';
        modal.style.opacity = '0';
        modal.style.transition = 'visibility 0.3s, opacity 0.3s';
        // 創建模態框內容
        const modalContent = document.createElement('div');
        modalContent.style.position = 'relative';
        modalContent.style.backgroundColor = 'white';
        modalContent.style.padding = '20px';
        modalContent.style.borderRadius = '8px';
        modalContent.style.textAlign = 'center';
        modalContent.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
        modalContent.style.width = '500px';
        // 添加關閉按鈕
        const closeButton = document.createElement('span');
        closeButton.textContent = '×';
        closeButton.style.position = 'absolute';
        closeButton.style.top = '10px';
        closeButton.style.right = '10px';
        closeButton.style.fontSize = '20px';
        closeButton.style.fontWeight = 'bold';
        closeButton.style.cursor = 'pointer';
        modalContent.appendChild(closeButton);
        // 添加文字
        const message = document.createElement('p');
        message.innerHTML = updateMassages_1.updateMessages.modalMessage;
        modalContent.appendChild(message);
        message.style.textAlign = 'left';
        // 將內容添加到模態框
        modal.appendChild(modalContent);
        document.body.appendChild(modal); // 將模態框插入到 body
        // 點擊按鈕顯示模態框
        guildlineButton.addEventListener('click', () => {
            modal.style.visibility = 'visible';
            modal.style.opacity = '1';
        });
        // 點擊關閉按鈕隱藏模態框
        closeButton.addEventListener('click', () => {
            modal.style.visibility = 'hidden';
            modal.style.opacity = '0';
        });
        return guildlineButton;
    }
    createArticleButton() {
        // 創建按鈕
        const articleButton = document.createElement('sl-icon-button');
        articleButton.id = 'articleButton';
        articleButton.className = 'article-btn right-button';
        articleButton.setAttribute('name', 'layout-text-sidebar-reverse');
        articleButton.style.fontSize = '2rem';
        // 創建模態框
        const modal = document.createElement('div');
        modal.id = 'comingSoonModal';
        modal.style.position = 'fixed';
        modal.style.top = '0';
        modal.style.left = '0';
        modal.style.width = '100%';
        modal.style.height = '100%';
        modal.style.display = 'flex';
        modal.style.justifyContent = 'center';
        modal.style.alignItems = 'center';
        modal.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        modal.style.zIndex = '1000';
        modal.style.visibility = 'hidden';
        modal.style.opacity = '0';
        modal.style.transition = 'visibility 0.3s, opacity 0.3s';
        // 創建模態框內容
        const modalContent = document.createElement('div');
        modalContent.style.position = 'relative';
        modalContent.style.backgroundColor = 'white';
        modalContent.style.padding = '20px';
        modalContent.style.borderRadius = '8px';
        modalContent.style.textAlign = 'center';
        modalContent.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
        modalContent.style.width = '500px';
        // 添加關閉按鈕
        const closeButton = document.createElement('span');
        closeButton.textContent = '×';
        closeButton.style.position = 'absolute';
        closeButton.style.top = '10px';
        closeButton.style.right = '10px';
        closeButton.style.fontSize = '20px';
        closeButton.style.fontWeight = 'bold';
        closeButton.style.cursor = 'pointer';
        modalContent.appendChild(closeButton);
        // 添加文字
        const message = document.createElement('p');
        message.innerHTML = columnArticle_1.columnArticle.modalMessage;
        modalContent.appendChild(message);
        // message.style.textAlign = 'left';
        modal.appendChild(modalContent);
        document.body.appendChild(modal);
        articleButton.addEventListener('click', () => {
            modal.style.visibility = 'visible';
            modal.style.opacity = '1';
        });
        closeButton.addEventListener('click', () => {
            modal.style.visibility = 'hidden';
            modal.style.opacity = '0';
        });
        return articleButton;
    }
}
exports.default = PlayerController;
